import { startBalanceQualificationQuery } from '@b-stock/fe-core/bstock-next/queries'
import type {
  StartQualificationRequest,
  StartQualificationResponse,
  BalanceApiStartQualificationRequest,
} from '@b-stock/payments-methods-api-client'

const startNetTermsQualification = async (
  payload: StartQualificationRequest,
  accessToken: string
): Promise<StartQualificationResponse> => {
  const balanceApiParams: BalanceApiStartQualificationRequest = {
    startQualificationRequest: payload,
  }

  return startBalanceQualificationQuery.fetchWithoutReactQuery(
    accessToken,
    balanceApiParams
  )
}

export default startNetTermsQualification
